/* eslint-disable @typescript-eslint/naming-convention */

export interface Language {
  code: string;
  name: string;
  nativeName: string;
  dir: 'ltr' | 'rtl';
}

export const languages: Language[] = [
  { code: 'en', name: 'English', nativeName: 'English', dir: 'ltr' },
  { code: 'id', name: 'Bahasa Indonesia', nativeName: 'Bahasa Indonesia', dir: 'ltr' },
  { code: 'hi', name: 'Hindi', nativeName: 'हिंदी', dir: 'ltr' },
];

export const supportedLngs = languages.map(l => l.code);
export const defaultLng = 'en';
